import { Directive, ElementRef, Output, EventEmitter, HostListener } from '@angular/core'
import { ClickOutsideService } from './click-outside.service'

@Directive({
  selector: '[clickOutside]'
})
export class ClickOutsideDirective {
  @Output()
  public clickOutside = new EventEmitter<MouseEvent>()

  constructor(private _elementRef: ElementRef,
              private clickOutsideService: ClickOutsideService) {
  }

  @HostListener('document:click', ['$event', '$event.target'])
  public onClick(event: MouseEvent, targetElement: HTMLElement): void {
    if (!targetElement) {
      return
    }

    const clickedInside = this._elementRef.nativeElement.contains(targetElement)
    const triggerElem = this.clickOutsideService.clickedElem$.getValue()
    const clickedTrigger = triggerElem
      ? triggerElem.nativeElement.contains(targetElement)
      : false

    if (!clickedInside && !clickedTrigger) {
      this.clickOutside.emit(event)
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/click-outside/click-outside.directive.ts